import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';
import { Sparkles } from 'lucide-react';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div style={styles.page}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fredoka:wght@400;500;600;700&family=Nunito:wght@400;600;700;800&display=swap');
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}
        .float-logo{animation:float 3s ease-in-out infinite;}
      `}</style>
      <div style={styles.bg} />
      <div style={styles.card}>
        <div style={styles.logoRow}>
          <div style={styles.logoIconWrap} className="float-logo">
             <Sparkles size={32} color="#FFF" strokeWidth={3} />
          </div>
          <div>
            <div style={styles.logoText}>mono</div>
            <div style={styles.logoSub}>DIGITAL MARKETING</div>
          </div>
        </div>
        <p style={styles.tagline}>Adapt. Dominate. Grow. <span style={{fontSize:18}}>💪</span></p>
        
        {error && <div style={styles.error}>{error}</div>}
        
        <form onSubmit={submit}>
          <label style={styles.label}>Email</label>
          <input name="email" type="email" value={form.email} onChange={handle}
            placeholder="you@brand.com" required style={styles.input} />
          <label style={styles.label}>Password</label>
          <input name="password" type="password" value={form.password} onChange={handle}
            placeholder="••••••••" required style={styles.input} />
          <button type="submit" disabled={loading} style={styles.btn}>
            {loading ? 'Signing in…' : 'Sign in →'}
          </button>
        </form>
        <div style={styles.footer}>
          No account? <Link to="/register" style={styles.link}>Create one free</Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight:'100vh', background:'#FFD166', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'"Nunito", sans-serif', position:'relative', overflow:'hidden' },
  bg: { position:'absolute', inset:0, backgroundImage:'radial-gradient(#222 1.5px, transparent 1.5px)', backgroundSize:'40px 40px', opacity:0.1, pointerEvents:'none' },
  card: { background:'#FFF', border:'4px solid #222', borderRadius:24, padding:'44px 40px', width:'100%', maxWidth:440, position:'relative', zIndex:1, boxShadow:'8px 8px 0px #222' },
  logoRow: { display:'flex', alignItems:'center', gap:16, marginBottom:16 },
  logoIconWrap: { width:54, height:54, borderRadius:16, background:'#FF5C5C', border:'3px solid #222', boxShadow:'2px 2px 0px #222', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 },
  logoText: { fontFamily:'"Fredoka", sans-serif', fontSize:38, fontWeight:700, color:'#222', textShadow:'1px 1px 0 #118AB2, 2px 2px 0 #222', letterSpacing:'-1px', lineHeight:1 },
  logoSub: { fontFamily:'"Fredoka", sans-serif', fontSize:10, letterSpacing:'0.15em', color:'#FF5C5C', fontWeight:800, marginTop:4 },
  tagline: { fontSize:16, color:'#444', marginBottom:32, fontWeight:700, fontFamily:'"Nunito", sans-serif' },
  label: { display:'block', fontSize:14, fontFamily:'"Fredoka", sans-serif', fontWeight:700, color:'#222', marginBottom:8, letterSpacing:'0.02em' },
  input: { width:'100%', background:'#F6F8FA', border:'3px solid #222', borderRadius:12, padding:'14px 16px', color:'#222', fontSize:16, outline:'none', boxSizing:'border-box', marginBottom:20, fontFamily:'"Nunito", sans-serif', fontWeight:700 },
  btn: { width:'100%', background:'#118AB2', border:'3px solid #222', boxShadow:'4px 4px 0px #222', borderRadius:14, padding:'16px', color:'#fff', fontSize:18, fontWeight:800, cursor:'pointer', fontFamily:'"Fredoka", sans-serif', letterSpacing:'0.02em', transition:'transform 0.1s', transform:'translate(0,0)' },
  error: { background:'#FFF0F0', border:'3px solid #EF476F', borderRadius:12, padding:'12px 16px', color:'#222', fontSize:14, fontFamily:'"Nunito", sans-serif', fontWeight:700, marginBottom:20 },
  link: { color:'#FF5C5C', textDecoration:'none', fontWeight:800, borderBottom:'2px solid #FF5C5C' },
  footer: { textAlign:'center', marginTop:28, color:'#666', fontSize:15, fontWeight:700 },
};
